import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=6f159f1b&"
import script from "./SuccessDialog.vue?vue&type=script&lang=ts&"
export * from "./SuccessDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports